<template>
  <ds-dialog :id="id" size="lg" :title="label" @close="$emit('close')">
    <div class="media-preview">
      <img :src="sasUrl" :alt="label" class="media-preview__image" />
    </div>
    <template #footer>
      <ds-button variant="text" data-qa="media-preview-close-button" @click="$emit('close')">
        Sluiten
      </ds-button>
      <ds-button data-qa="media-preview-download-button" @click="$emit('download')">
        <ds-icon name="download" />
        Downloaden
      </ds-button>
    </template>
  </ds-dialog>
</template>

<script>
import DsButton from '@/components/ds/atoms/dsButton/DsButton.vue'
import DsIcon from '@/components/ds/atoms/dsIcon/DsIcon.vue'
import DsDialog from '@/components/ds/molecules/dsDialog/DsDialog.vue'

export default {
  name: 'MediaPreviewModal',
  components: { DsButton, DsIcon, DsDialog },
  props: {
    // Distinguishes the current-file preview from the version preview in data-qa.
    id: { type: String, default: 'media-preview' },
    sasUrl: { type: String, required: true },
    label: { type: String, required: true },
  },
  emits: ['close', 'download'],
}
</script>

<style lang="scss" scoped>
.media-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--ds-space-5);
  border-radius: var(--ds-radius-md);
  background: var(--ds-color-surface-sunken);
}

.media-preview__image {
  max-width: 100%;
  max-height: 60vh;
  object-fit: contain;
  border-radius: var(--ds-radius-sm);
  box-shadow: var(--ds-shadow-sm);
}
</style>
